import React from "react";

function LoginStep() {
  if (localStorage.getItem("token")) {
    return "/";
  } else if (localStorage.getItem("tokenfa")) {
    return "/twofa";
  } else if (localStorage.getItem("tokenreg")) {
    return "/register";
  } else {
    return "/login";
  }
}
export default LoginStep;
